<template>
  <div id="ll-signup">
    <ProgrammeSignup
      :title="title"
      :programmeCode="programmeCode"
      :ctaButton="ctaButton"
      :themeColor="themeColor"
      :sale="sale"
      logo="/assets/images/list-love-logo.png"
    >
      <template v-slot:sidebar>
        <div class="included mt-5 mt-lg-0">
          <h2>The 1-Year List Love Program includes:</h2>
          <div
            v-for="(included, index) in includedContent"
            :key="index"
            class="smaller py-2"
          >
            <i class="fa fa-check c-coral mr-2"></i>
            <span v-if="included.bonus" class="bonus mr-2">{{
              included.bonus
            }}</span>
            <span>{{ included.description }}</span>
          </div>
        </div>
        <div class="included mt-5">
          <h5>With Marvelous Software you get:</h5>
          <div
            v-for="(included, index) in marvelousIncludedContent"
            :key="index"
            class="smaller py-2"
          >
            <i class="fa fa-check c-coral mr-2"></i>
            <span v-if="included.bonus" class="bonus mr-2">{{
              included.bonus
            }}</span>
            <span>{{ included.description }}</span>
          </div>
        </div>
        <div class="included mt-5">
          <h2>Privacy</h2>
          <p class="smaller mt-3">
            We will not share or trade online information that you provide us
            (including e-mail addresses).
          </p>
          <span>
            <i class="fal fa-user-shield c-coral mr-2"></i>
            <span class="smaller c-dark-gray">Your privacy is protected</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Security</h2>
          <p class="smaller mt-3">
            All personal information you submit is encrypted and secure.
          </p>
          <span>
            <i class="fal fa-lock-alt c-coral mr-2"></i>
            <span class="smaller c-dark-gray">Your information is secure</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Need help?</h2>
          <div class="small mt-3">
            Email:
            <a href="mailto:team@heymarvelous.com" class="c-coral"
              >team@heymarvelous.com</a
            >
          </div>
        </div>
      </template>
    </ProgrammeSignup>
  </div>
</template>

<script>
import ProgrammeSignup from '@/web/views/admin/ProgrammeSignup';
export default {
  name: 'ListLoveProgrammeSignup',
  components: { ProgrammeSignup },
  props: {
    title: {
      type: String,
      default: null,
    },
    programmeCode: {
      type: String,
      default: null,
    },
    ctaButton: {
      type: String,
      default: 'SIGNUP.BUTTON.GET_STARTED',
    },
    themeColor: {
      type: String,
      default: 'lwi',
    },
    sale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    includedContent() {
      return [
        {
          description: 'The List Love Bootcamp (Value $1,997)',
        },
        {
          description: 'The List Love Bootcamp Recordings',
        },
        {
          description: '12-Months of Monthly Drop-in Group Coaching ($4,600)',
        },
        {
          bonus: 'BONUS:',
          description:
            'Private Community with Your Coaches and Peers (priceless)',
        },
        {
          bonus: 'BONUS:',
          description: 'Email Nurture Sequence Templates (Value $1,500)',
        },
        {
          bonus: 'BONUS:',
          description: 'Social Media Marketing with Intention (Value $199)',
        },
        {
          description: 'Marvelous Software',
        },
      ];
    },
    marvelousIncludedContent() {
      return [
        {
          description:
            '1-Year Subscription to Pro Plan of Marvelous Software (Value $1,790)',
        },
        {
          bonus: 'TOTAL VALUE OVER',
          description: '$10,000',
        },
      ];
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Work+Sans&display=swap');

@font-face {
  font-family: 'ivy_modelight';
  src: url('~@/assets/fonts/ivymode-light-webfont.woff2') format('woff2'),
    url('~@/assets/fonts/ivymode-light-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

#ll-signup {
  font-family: 'Work Sans', sans-serif;

  h1,
  h2,
  h3 {
    font-family: 'ivy_modelight';
  }

  a {
    color: $coral !important;
  }
}

.included {
  color: $black;
  line-height: 26px;

  h2 {
    color: $dark-gray;
  }

  .bonus {
    text-transform: uppercase;
    color: $coral;
  }
}
</style>
